import React from 'react';
import { Button } from '../ui/button';
import { Loader2, MessageCircle } from 'lucide-react';

/**
 * The three primary OAuth-style buttons:
 *  - Continue with Google  (data-testid="auth-google-btn")
 *  - Continue with WhatsApp (data-testid="auth-whatsapp-toggle")
 *
 * Email/password is a separate dropdown component.
 */
export const OAuthButtons = ({
  onGoogleClick,
  onWhatsAppClick,
  googleLoading,
  showWhatsAppButton,
}) => (
  <>
    <Button
      onClick={onGoogleClick}
      disabled={googleLoading}
      data-testid="auth-google-btn"
      className="w-full mb-3 bg-white hover:bg-slate-50 text-slate-800 border border-slate-300 py-6 font-semibold"
    >
      {googleLoading ? (
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
      ) : (
        <svg className="h-5 w-5 mr-3" viewBox="0 0 48 48">
          <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z" />
          <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2c-2 1.5-4.5 2.4-7.2 2.4-5.3 0-9.7-3.4-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
          <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.2 5.6l6.2 5.2c-.4.4 6.7-4.9 6.7-14.8 0-1.3-.1-2.4-.4-3.5z" />
        </svg>
      )}
      Continue with Google
    </Button>

    {showWhatsAppButton && (
      <Button
        onClick={onWhatsAppClick}
        data-testid="auth-whatsapp-toggle"
        className="w-full mb-3 bg-[#25D366] hover:bg-[#1FAD52] text-white py-6 font-semibold"
      >
        <MessageCircle className="h-5 w-5 mr-2" />
        Continue with WhatsApp
      </Button>
    )}
  </>
);

export default OAuthButtons;
